import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

// Optionally, define a base structure for headers
interface BaseHeaders {
    [key: string]: string;
}

interface EventType {
  mitt: any,
  type: string,
}

export class AxiosCustomInstance<T extends BaseHeaders = BaseHeaders> { // Default to BaseHeaders if no specific type is provided
    private axiosInstance: AxiosInstance;
    private event: EventType;

    constructor(baseURL: string, headers?: T, event?: EventType, timeout: number = 10000) {
        const axiosConfig: AxiosRequestConfig = {
            baseURL,
            timeout,
            headers,
        };

        this.event = event;
        this.axiosInstance = axios.create(axiosConfig);

        this.initializeResponseInterceptor();
    }

    private initializeResponseInterceptor() {
        this.axiosInstance.interceptors.response.use(
            this.handleResponse,
            this.handleError,
        );
    }

    private handleResponse = (response: AxiosResponse) => response;

    private handleError = (error: any) => {
        if (error.response && error.response.status === 401) {
            if(this.event?.mitt) {
              this.event.mitt.emit(this.event.type);
            }
        }
        return Promise.reject(error);
    }

    getInstance() {
      return this.axiosInstance;
    }
}